'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _AirOption = require('./AirOption.jsx');

var _AirOption2 = _interopRequireDefault(_AirOption);

var _AvailabilityOption = require('./AvailabilityOption.jsx');

var _AvailabilityOption2 = _interopRequireDefault(_AvailabilityOption);

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Email = function (_Component) {
  (0, _inherits3.default)(Email, _Component);

  function Email() {
    (0, _classCallCheck3.default)(this, Email);
    return (0, _possibleConstructorReturn3.default)(this, (Email.__proto__ || (0, _getPrototypeOf2.default)(Email)).apply(this, arguments));
  }

  (0, _createClass3.default)(Email, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          components = _props.components,
          shopOptions = _props.shopOptions;

      var airOptions = shopOptions.options.filter(function (option) {
        return option.optionType === 'Air';
      });
      var availabilityOptions = shopOptions.options.filter(function (option) {
        return option.optionType === 'Availability';
      });
      var styleAir = (0, _emailStyleTools.containerStyles)(components, 'flight');

      return _react2.default.createElement(
        'table',
        { style: _emailStyleTools.fullMinimal, 'data-component': 'Air-EMAIL_ROOT' },
        _react2.default.createElement(
          'tbody',
          null,
          (airOptions.length || null) && airOptions.map(function (airOption, i) {
            return _react2.default.createElement(
              'tr',
              { key: i },
              _react2.default.createElement(
                'td',
                { style: (0, _extends3.default)({}, styleAir, _emailStyleTools.padTen) },
                _react2.default.createElement(_AirOption2.default, {
                  components: components,
                  option: airOption,
                  key: i
                })
              )
            );
          }),
          (availabilityOptions.length || null) && availabilityOptions.map(function (option, i) {
            return _react2.default.createElement(
              'tr',
              { key: i },
              _react2.default.createElement(
                'td',
                { style: (0, _extends3.default)({}, styleAir, _emailStyleTools.padTen) },
                _react2.default.createElement(_AvailabilityOption2.default, {
                  option: option
                })
              )
            );
          })
        )
      );
    }
  }]);
  return Email;
}(_react.Component);

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components,
    shopOptions: state.rendering.shopOptions
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(Email);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/Email.jsx
// module id = 1477
// module chunks = 0